import { 
  CREATE_BRANDKIT_BUTTON, DELETE_BRANDKIT_BUTTON, UPDATE_BRANDKIT_BUTTON_PROPERTY, 
  UPDATE_BRANDKIT_BUTTON_CONTENT, RENAME_BRANDKIT_BUTTON, ASSOCIATE_FONTS_WITH_BRANDKIT_BUTTON,
  FETCHING_BRANDKIT_BUTTONS_REQUEST, FETCHING_BRANDKIT_BUTTONS_SUCCEEDED, FETCHING_BRANDKIT_BUTTONS_FAILED,
  DELETE_BRANDKIT_BUTTONS_REQUEST, DELETING_BRANDKIT_BUTTONS_SUCCEEDED, DELETING_BRANDKIT_BUTTONS_FAILED,
  UPDATE_BRANDKIT_BUTTONS_REQUEST, UPDATING_BRANDKIT_BUTTONS_SUCCEEDED, UPDATING_BRANDKIT_BUTTONS_FAILED,
  INVALIDATE_BRANDKIT_BUTTON,
  RELOAD_EDITOR_BRAND_COMPONENT_SUCCEEDED
  } from "constants/actionTypes";
    
  import _ from 'lodash';
    
    const initialState = {
      loading: false,
      updating: false,
      fetched: false,
      invalidated: false,
      errorType: null,
      items: [],
      components: [],
      invalidated: false
    }
  
    
    export function brandKitButtonsReducer(state = initialState, action) {
      switch (action.type) {

        case CREATE_BRANDKIT_BUTTON: {
          var { component } = action.payload;
  
          const existingComponents = [...state.components];

          if (existingComponents.length != 0) {
            component = {
              ...component,
              changes: true,
              order: existingComponents.length + 1
            }
          }
  
          var updatedState = {
            ...state,
            components: [...existingComponents, component],
          }
  
          return updatedState;
        }

        case DELETE_BRANDKIT_BUTTON: {
          const { ids } = action.payload;

          const updatedComponents = state.components.filter(component => !ids.includes(component.id));

          return {
            ...state,
            components: updatedComponents
          }

        }

        case UPDATE_BRANDKIT_BUTTON_PROPERTY: {
          const { id, widget_uid, property } = action.payload;
        
          const components = state.components || [];
          
          const updatedComponents = components.map(component => {
            if (component.id === id) {
              const updatedWidgets = component.draft.widgets.map(widget => {
                if (widget.uid === widget_uid) {
                  return {
                    ...widget,
                    properties: property
                  };
                }
                return widget;
              });
        
              return {
                ...component,
                changes: true,
                draft: {
                  ...component.draft,
                  widgets: updatedWidgets,
                },
              };
            }
            return component;
          });
        
          return {
            ...state,
            components: updatedComponents,
          };
        }
        
        case UPDATE_BRANDKIT_BUTTON_CONTENT: {
          const { id, widget_uid, content } = action.payload;

          const components = state.components || [];

          const updatedComponents = components.map(component => {
            if (component.id === id) {
              const updatedWidgets = component.draft.widgets.map(widget => {
                if (widget.uid === widget_uid) {
                  return {
                    ...widget,
                    content: content
                  };
                }
                return widget;
              });
        
              return {
                ...component,
                changes: true,
                draft: {
                  ...component.draft,
                  widgets: updatedWidgets,
                },
              };
            }
            return component;
          });
        
          return {
            ...state,
            components: updatedComponents,
          };
        }

        case RENAME_BRANDKIT_BUTTON: {
          const { id, widget_uid, name } = action.payload;

          const components = state.components || [];

          const updatedComponents = components.map(component => {
            if (component.id === id) {
              const updatedWidgets = component.draft.widgets.map(widget => {
                if (widget.uid === widget_uid) {
                  return {
                    ...widget,
                    name: name
                  };
                }
                return widget;
              });
        
              return {
                ...component,
                changes: true,
                name: name,
                draft: {
                  ...component.draft,
                  widgets: updatedWidgets,
                },
              };
            }
            return component;
          });
        
          return {
            ...state,
            components: updatedComponents,
          };
        }

        case ASSOCIATE_FONTS_WITH_BRANDKIT_BUTTON: {
          const { id, widget_uid, fonts } = action.payload;
  
          const components = state.components || [];
  
          const updatedComponents = components.map(component => {
            if (component.id === id) {
              const updatedWidgets = component.draft.widgets.map(widget => {
                if (widget.uid === widget_uid) {
                  return {
                    ...widget,
                    fonts: fonts
                  };
                }
                return widget;
              });
        
              return {
                ...component,
                changes: true,
                draft: {
                  ...component.draft,
                  widgets: updatedWidgets,
                },
              };
            }
            return component;
          });
        
          return {
            ...state,
            components: updatedComponents,
          };
        }
    
        case FETCHING_BRANDKIT_BUTTONS_REQUEST: {
          return {
            ...state,
            loading: true
          }
        }
        
        case FETCHING_BRANDKIT_BUTTONS_SUCCEEDED: {
          return {
            ...state,
            loading: false,
            items: action.payload,
            components: action.payload.components
          }
        }
    
        case FETCHING_BRANDKIT_BUTTONS_FAILED: {
          return {
            ...state,
            loading: false,
            error: action.payload
          }
        }
    
        case DELETE_BRANDKIT_BUTTONS_REQUEST: {
  
          return {
              ...state,
              deleting: true,
            }
        }
    
        case DELETING_BRANDKIT_BUTTONS_SUCCEEDED: {
          const { ids, response } = action.payload;
          
          const components = state.components.filter(item => (!(ids).includes(item.id)));
    
          return {
            ...state,
            loading: false,
            deleting: false,
            components: components,
          }
        }
    
        case DELETING_BRANDKIT_BUTTONS_FAILED: {
          return {
            ...state,
            deleting: false,
            loading: false,
            error: action.payload.error[0]
          }
        }
    
        case UPDATE_BRANDKIT_BUTTONS_REQUEST: {
          return {
            ...state,
            loading: true,
            updating: true
          }
        }
          
        case UPDATING_BRANDKIT_BUTTONS_SUCCEEDED: { 
          const {response} = action.payload;

          return {
            ...state,
            loading: false,
            updating: false,
            updated: true,
            items: response,
            components: response.components
          }
        }
          
        case UPDATING_BRANDKIT_BUTTONS_FAILED: {
          return {
            ...state,
            updating: false,
            loading: false,
            error: action.payload.error[0]
          }
        }

        case RELOAD_EDITOR_BRAND_COMPONENT_SUCCEEDED: {
          const { response, type } = action.payload;
          const components = state.components || [];

          if (!state.components || type !== 'BUTTON') {
            return state;
          }

          let items = [response.components, ...(components || [])];
          items = _.uniqBy(items, 'id');
  
          return {
            ...state,
            components: items,
          }
        }

        case INVALIDATE_BRANDKIT_BUTTON: {
          return {
            ...state,
            loading: false,
            updating: false,
            updated: false,
            fetched: false,
            invalidated: false,
            errorType: null,
            invalidated: false
          }
        }
           
        default:
          return state;
      }
    }
    
    